import { OtpContextEnum } from "../../network/enum";
import { validateOtp } from "../../network/network";
import { handlerError } from "./handle-otp-error";

export const validateOtpFunc = async (props: {
  otp: string;
  regionCode: string;
  phone: string;
}) => {
  const { otp, regionCode, phone } = props;
  try {
    const res = await validateOtp({
      context: OtpContextEnum.PublicSharing,
      username: `${regionCode} ${phone}`,
      otp: otp,
    });
    return handlerError(res);
  } catch (e) {
    return handlerError(e);
  }
};
